// extracted by mini-css-extract-plugin
export default {"eventDescription":"W0S903","sideBySide":"PUuajU","descriptionSpacing":"jAckT9"};